// extracted by mini-css-extract-plugin
export default {"discount":"discount__1QhwO","discountIcon":"discountIcon__2Cfo0","discountDescription":"discountDescription__3SVVO","discountTitle":"discountTitle__1aQhz","discountLabel":"discountLabel__jA4Uu"};
    if(module.hot) {
      // 1745482222205
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  